// Decodificación tolerante del payload de un JWT (sin verificar firma: solo
// para leer claims informativos en el navegador, p.ej. el modo impersonación).
// Nunca lanza: ante cualquier token malformado devuelve null.

export const decodeJwtClaims = (token: string): Record<string, unknown> | null => {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(b64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const claims = JSON.parse(json);
    return claims && typeof claims === 'object' ? (claims as Record<string, unknown>) : null;
  } catch {
    return null;
  }
};

// ¿El token es de impersonación (partner «viendo como cliente», solo lectura)?
// El backend está en construcción: aceptamos varias formas razonables del claim
// para no acoplarnos a un nombre exacto. Cualquier señal positiva ⇒ true.
export const isImpersonationClaims = (claims: Record<string, unknown> | null): boolean => {
  if (!claims) return false;
  const truthy = (v: unknown) => v === true || v === 'true' || v === 1;
  if (truthy(claims.impersonation) || truthy(claims.impersonated) || truthy(claims.is_impersonation)) return true;
  if (truthy(claims.read_only) || truthy(claims.readonly)) return true;
  const strEq = (v: unknown, s: string) => typeof v === 'string' && v.toLowerCase() === s;
  if (strEq(claims.mode, 'impersonation') || strEq(claims.scope, 'impersonation') || strEq(claims.token_use, 'impersonation')) return true;
  if (typeof claims.act_as === 'string' && claims.act_as !== '') return true;
  if (typeof claims.impersonated_by === 'string' && claims.impersonated_by !== '') return true;
  return false;
};
